import {
  Box,
  Grid,
  Switch,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { TWO_FA } from "../../../../redux/types/auth.types";
import styles from "./2FA.module.scss";

const _2FA = ({ isTwoFaEnabled }) => {
  const dispatch = useDispatch();

  const handleToggle = (event) => {
    dispatch({ type: TWO_FA, payload: { isTwoFaEnabled: event.target.checked } });
  };

  return (
    <Box className={styles.notificationContainer}>
      <Grid container alignItems="baseline">
        <Grid item xs>
          <Typography variant="subtitle1" className={styles.label}>
            {isTwoFaEnabled ? "Disable 2FA" : "Enable 2FA"}
          </Typography>
        </Grid>
        <Grid item className={styles.checkboxContainer}>
          <Switch
            checked={isTwoFaEnabled}
            onChange={handleToggle}
            color="primary"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default _2FA;
